import { Link } from "react-router-dom";
import styled from "styled-components";
import CouponCard from "../cards/CouponCard";
import { cPath } from "../../constants";

const Lead = styled.p`
  font-size: 0.875rem;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  margin: 0 0 1.5rem;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const Empty = styled.div`
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.lg};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  padding: 3rem;
  text-align: center;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
`;

const AlertCard = styled.div`
  margin-top: 1.5rem;
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.lg};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

const AlertText = styled.p`
  margin: 0;
  font-weight: 600;
  color: hsl(${({ theme }) => theme.colors.foreground});
`;

const Row = styled.div`
  display: flex;
  gap: 0.5rem;
  flex: 1;
  width: 100%;
`;

const Input = styled.input`
  flex: 1;
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  border-radius: ${({ theme }) => theme.radius.lg};
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  background: hsl(${({ theme }) => theme.colors.background});
  color: hsl(${({ theme }) => theme.colors.foreground});
  outline: none;
  &:focus {
    box-shadow: 0 0 0 2px hsl(${({ theme }) => theme.colors.primary} / 0.3);
  }
`;

const Btn = styled.button`
  background: hsl(${({ theme }) => theme.colors.accent});
  color: hsl(${({ theme }) => theme.colors.accentForeground});
  padding: 0.5rem 1.5rem;
  border-radius: ${({ theme }) => theme.radius.lg};
  font-weight: 600;
  font-size: 0.875rem;
  white-space: nowrap;
  &:hover {
    opacity: 0.9;
  }
`;

function formatPromoDate(d = new Date()) {
  return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
}

export default function StoreCouponsColumn({ store, coupons, storeName, storeCoupons }) {
  const name = store?.name || storeName || "Store";
  const list = Array.isArray(coupons) ? coupons : Array.isArray(storeCoupons) ? storeCoupons : [];

  return (
    <div>
      <Lead>Top {name} Promo Codes for {formatPromoDate()}</Lead>
      <List>
        {list.map((c) => (
          <CouponCard key={c.id} coupon={c} />
        ))}
      </List>
      {list.length === 0 && (
        <Empty>
          <p>No coupons available for this store right now.</p>
          <Link
            to={cPath("submit-deal")}
            style={{
              marginTop: 8,
              display: "inline-block",
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "hsl(221 67% 44%)",
            }}
          >
            Submit a coupon for {name}
          </Link>
        </Empty>
      )}
      <AlertCard>
        <AlertText>Get {name} coupons instantly!</AlertText>
        <Row>
          <Input type="email" placeholder="Enter email" />
          <Btn type="button">Get Alerts</Btn>
        </Row>
      </AlertCard>
    </div>
  );
}
